(() => {
  function referralUrl() {
    // Reuse the store's identified Smile customer. No second SDK, credentials, or customer lookup.
    const customer = window.Smile?.customer;
    if (!customer || customer.state !== 'member') return null;
    try {
      const value = customer.referral_url;
      if (typeof value !== 'string' || !value.trim()) return null;
      const url = new URL(value);
      return /^(https?:)$/.test(url.protocol) && !url.username && !url.password ? url.href : null;
    } catch (_) { return null; }
  }
  function refresh() {
    const url = referralUrl();
    document.querySelectorAll('[data-pm-referral-actions]').forEach(card => {
      card.querySelector('[data-pm-referral-fallback]').hidden = Boolean(url);
      card.querySelector('[data-pm-referral-ready]').hidden = !url;
      card.querySelector('[data-pm-referral-url]').value = url || '';
      card.querySelector('[data-pm-referral-share]').hidden = !url || typeof navigator.share !== 'function';
      if (card.dataset.ready !== String(Boolean(url))) {
        card.querySelector('[data-pm-referral-status]').textContent = url ? 'Send your link to a new friend. They claim their $10 reward before ordering.' : 'Sign in to copy your personal link or share it with a friend.';
        card.dataset.ready = String(Boolean(url));
      }
    });
  }
  document.addEventListener('click', async event => {
    const calendar = event.target.closest('[data-pm-growth-calendar]');
    if (calendar) {
      document.dispatchEvent(new CustomEvent('pm:delivery-calendar:open', {detail:{trigger:calendar}}));
      return;
    }
    const button = event.target.closest('[data-pm-referral-copy], [data-pm-referral-share]');
    if (!button) return;
    const card = button.closest('[data-pm-referral-actions]');
    const url = referralUrl();
    if (!url) { refresh(); return; }
    const status = card.querySelector('[data-pm-referral-status]');
    try {
      if (button.hasAttribute('data-pm-referral-share') && navigator.share) {
        await navigator.share({title: 'Try Purefect Meals — $10 off', text: 'Enjoy $10 off your first Purefect Meals order. No order minimum. Claim your reward through my link:', url});
        status.textContent = 'Your sharing options are ready.';
      } else {
        await navigator.clipboard.writeText(url);
        status.textContent = 'Link copied! Send it to a friend to give them $10 off.';
      }
    } catch (error) {
      if (error.name === 'AbortError') return;
      const field = card.querySelector('[data-pm-referral-url]'); field.focus(); field.select();
      status.textContent = 'Your link is selected. Copy it to share with your friend.';
    }
  });
  refresh();
  document.addEventListener('smile-ui-loaded', refresh);
  document.addEventListener('pm:loyalty-customer-updated', refresh);
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', refresh);
  let attempts = 0;
  const timer = setInterval(() => { refresh(); if (++attempts >= 15) clearInterval(timer); }, 2000);
  if (new URLSearchParams(location.search).get('first-order') === '1') {
    const section = document.getElementById('purefect-first-order');
    if (section) requestAnimationFrame(() => section.scrollIntoView({block:'start'}));
  }
})();
